export default __webpack_public_path__ + "static/media/historial-prestaciones.521e83dd.svg";